var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex items-center"},[(typeof _vm.value === 'object' && _vm.value && _vm.value.code && _vm.value.name)?[_c('div',{staticClass:"flex justify-center items-center"},[_c('div',{staticClass:"mr-2",staticStyle:{"width":"20px","height":"20px","border":"1px solid black","border-radius":"20px"},style:({
          background: _vm.value.code,
          border: _vm.value.code === '#FFFFFF' ? '1px solid black' : ''
        })}),_vm._v("\n      "+_vm._s(_vm.value.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }